import axios from "axios";
import { ArgumentNullError } from "../errors";

const ENDPOINT = 'vipSale';

export default {
    /**
     * @param {String} productCode
     * @param {String} oldSrsCode
     * @param {String} newSrsCode
     */
    async enqueueSrsCodeChangeAsync(productCode, oldSrsCode, newSrsCode) {
        ArgumentNullError.throw(productCode, 'productCode', this.enqueueSrsCodeChangeAsync.name)
        ArgumentNullError.throw(oldSrsCode, 'oldSrsCode', this.enqueueSrsCodeChangeAsync.name)
        ArgumentNullError.throw(newSrsCode, 'newSrsCode', this.enqueueSrsCodeChangeAsync.name)
        const response = await axios.post(`${ENDPOINT}/enqueueSrsCodeChange`, { productCode, oldSrsCode, newSrsCode })
        return response.data
    },

    /**
     * @param {String} product
     */
    async getByProductAsync(product) {
        ArgumentNullError.throw(product, 'product', this.getByProductAsync.name)
        const response = await axios.get(`${ENDPOINT}/product/${product}`)
        return response.data
    },

    /**
     * @param {String} supplierInternalId
     */
    async getBySupplierAsync(supplierInternalId) {
        ArgumentNullError.throw(supplierInternalId, 'supplierInternalId', this.getBySupplierAsync.name)
        const response = await axios.get(`${ENDPOINT}/supplier/${supplierInternalId}`)
        return response.data
    },

    /**
     * @param {String} supplierInternalId
     */
    async getBySupplierPagedAsync(supplierInternalId, { pageIndex, pageSize }) {
        ArgumentNullError.throw(supplierInternalId, 'supplierInternalId', this.getBySupplierAsync.name)
        ArgumentNullError.throw(pageIndex, 'pageIndex', this.getBySupplierAsync.name)
        ArgumentNullError.throw(pageSize, 'pageSize', this.getBySupplierAsync.name)
        const response = await axios.get(`${ENDPOINT}/supplier/${supplierInternalId}/paged`, {
            params: { pageIndex, pageSize }
        })
        return response.data
    },
}
